<template>
  <div>
    <info-box v-bind:description="description"></info-box>
    <header-title v-bind:title_img_src="title_img" />
    <nav-bar></nav-bar>

    <div v-if="userRates && currentUser" :style="{maxHeight: '85%'}" style="overflow-y: auto;">
      <div class="rate-title">
        <div :style="{fontSize: '1.5rem', fontWeight: 700}">Your Rate</div>
        <div :style="{fontSize: '2rem'}">{{formatCurrency(userRates.rate * 100)}}%</div>
      </div>
      <div class="rates-cont">
        <div class="rate-box">
          <div class="rate-info">
            <div class="title">Discord Connection</div>
            <div class="rate-val">+{{formatCurrency(userRates.discord * 100)}}%</div>
          </div>
          <AchievementProgressBar :progress="userRates.discord * 20" :achievements="[{reward: '+5% Bonus', requirement: 1}]"/>
          <div class="rate-desc">
            <div><div>{{userRates.discord != 0 ? 'Thanks for connecting your Discord to Swiftorland - this is your 5% bonus!' : 'Click on the Discord logo on the todiv right to get a 5% bonus for connecting your Discord account!'}}</div></div>
          </div>
        </div>
        <div class="rate-box">
          <div class="rate-info">
            <div class="title">Sub Tier</div>
            <div class="rate-val">+{{formatCurrency(userRates.subLevel * 100)}}%</div>
          </div>
          <AchievementProgressBar :progress="(userRates.subLevel) / 10"
          :achievements="[{reward: `+1000% Bonus`, requirement: 1}]"/>
          <div class="rate-desc"><div>Twitch & Discord Sub Bonus. Twitch Tier 1 = 100%, Tier 2= 300%, Tier 3 = 900%.  A <a href="https://discord.com/channels/94542586735230976/role-subscriptions" target="_blank">Discord paid sub</a> also stacks: Discord Tier 1 = 100%. </div></div>
        </div>
        <div class="rate-box">
          <div class="rate-info">
            <div class="title">Sub Gifts</div>
            <div class="rate-val">+{{formatCurrency(userRates.gifts * 100)}}%</div>
          </div>
          <AchievementProgressBar :progress="userRates.gifts" :achievements="[{reward: 'Custom ReSub Sound!', requirement: 0.5}, {reward: 'Custom Gift Sub Sound!', requirement: 1}]"/>
          <div class="rate-desc"><div>Every 5 gift subs of any tier on Twitch is 1% (after 100% it gets harder to increase)</div></div>
        </div>
        <div class="rate-box">
          <div class="rate-info">
            <div class="title">Gold + Tokens</div>
            <div class="rate-val">+{{formatCurrency(userRates.gold * 100)}}%</div>
          </div>
          <AchievementProgressBar :progress="userRates.gold" :achievements="[{reward: 'Custom Save Sound', requirement: 0.5}, {reward: 'Custom Kill Sound', requirement: 1}]"/>
          <div class="rate-desc"><div>Every 25 <a href="https://swiftorland.com/#/gold" target="_blank">Gold</a> obtained is 1% (after 100% it gets harder to increase). Save = 10 gold, Kill = 66. </div></div>
        </div>
        <div class="rate-box">
          <div class="rate-info">
            <div class="title">Cheer</div>
            <div class="rate-val">+{{formatCurrency(userRates.cheer * 100)}}%</div>
          </div>
          <AchievementProgressBar :progress="userRates.cheer" :achievements="[{reward: 'Custom Cheer Sound', requirement: 0.5}, {reward: '+100% Bonus', requirement: 1}]"/>
          <div class="rate-desc"><div>Every 2,500 cheer on Twitch is 1% (after 100% it gets harder to increase)</div></div>
        </div>
      </div>
    </div>
    <span v-else><login-btn buttonClass="btn-enabled" style="font-size: 40px; padding: 8px;">Login to View Rates!</login-btn></span>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import AchievementProgressBar from '@/components/AchievementProgressBar'
export default {
  name: 'rates',
  components: {
    AchievementProgressBar
  },
  computed: {
    ...mapState(['userRates', 'currentUser'])
  },
  data () {
    return {
      title_img: 'swiftorland-title.svg',
      description: {
        title: 'Loot Shop',
        text: `Spend SwiftBUCKS and SwiftGOLD on awesome loot!`
      }
    }
  },
  methods: {
    ...mapActions({
      fetchUserRates: 'fetchUserRates'
    })
  },
  mounted () {
    this.fetchUserRates()
  },
  watch: {
    currentUser () {
      this.$nextTick(() => {
        this.fetchUserRates()
      })
    }
  }
}
</script>

<style scoped>
.rate-title{
  background: #b62626;
  display: inline-block;
  margin: auto;
  padding: 1rem 2rem;
  border-radius: 1rem;
}

.rates-cont{
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: 1rem auto;
  max-width: 50rem;

}
.rate-box{
  background: #00000088;
  padding: .8rem 1.2rem;
  border-radius: .5rem;
}
.rate-info{
  display: flex;
  justify-content: space-between;
  justify-items: center;
  gap: 1rem;
  width: 100%;
}
.rate-info>.title{
  font-size: 1.8rem;
  font-weight: 700;
  margin: none;
}
.rate-info>.rate-val{
  font-size: 1.5rem;
}
.rate-box>.rate-desc{
  width: 100%;
  padding-top: 1rem;
  margin-top: 1rem;
  border-top: 1px gray solid;
  font-size: .8rem;
  color: gray;
  text-align: left;
}
.rate-box>.rate-desc a{
  text-decoration: underline;
  color: #b62626;
}
</style>


// WEBPACK FOOTER //
// src/components/Rates.vue